'use client'

import { useEffect } from 'react'
import { initProductionLogger } from '@/lib/production-logger'

/**
 * Client component to initialize production logger
 * Must be client component because it uses useEffect
 */
export function ProductionLoggerInit() {
  useEffect(() => {
    initProductionLogger()
  }, [])

  return null
}
